export class Tab {
  name;
  slug;
  iconClass;
  count;
  linkTo;

  constructor(name, slug, iconClass = "", count = 0, linkTo = undefined) {
    if (name == null) {
      throw "Tab class did not receive a name parameter.";
    }

    if (slug == null) {
      throw "Tab class did not receive a slug parameter.";
    }

    this.name = name;
    this.slug = slug;
    this.iconClass = iconClass;
    this.count = count;
    this.linkTo = linkTo;
  }
}
